import type { NormalizeOAS, OASRequestParams } from 'fets';
import type { ApiClient } from '../fetsClient';
import type openapi from '../openapi';
import { throwIfNotOk } from '../throwIfNotOk';

type O = NormalizeOAS<typeof openapi>;
type UploadRequestParams = OASRequestParams<O, '/api/project/upload-logo', 'post'>;
type ResetRequestParams = OASRequestParams<O, '/api/project/{id}/reset-logo', 'post'>;

type Params = {
  projectId: number;
  logo: File | null;
};

export const uploadLogoFactory = (apiClient: ApiClient) => {
  const uploadLogo = async (variables: Params): Promise<void> => {
    if (variables.logo === null) {
      const requestParams = mapInputToResetRequestParams(variables);
      const response = await apiClient['/api/project/{id}/reset-logo'].post(requestParams);
      await throwIfNotOk(response, 'reset the logo');
      return;
    }

    const requestParams = mapInputToUploadRequestParams({ projectId: variables.projectId, logo: variables.logo });
    const response = await apiClient['/api/project/upload-logo'].post(requestParams);
    await throwIfNotOk(response, 'upload the logo');
  };

  const mapInputToUploadRequestParams = (input: { projectId: number; logo: File }): UploadRequestParams => {
    return {
      formData: {
        projectId: input.projectId,
        formFile: input.logo,
      },
    };
  };

  const mapInputToResetRequestParams = (input: Params): ResetRequestParams => {
    return {
      params: {
        id: input.projectId,
      },
    };
  };

  return uploadLogo;
};
